import Vue from 'vue'
import Vuex from 'vuex'
import news from './modules/news'
import products from './modules/products'
import albums from './modules/albums'
import categories from './modules/categories'
import contactUs from './modules/contact-us'
import branches from './modules/branches'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
	},
	getters: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
		news,
		products,
		albums,
		categories,
		contactUs,
		branches
	}
})
